/**
 * Simula o shape real de POST /orders (CheckoutPresenter) para permitir
 * visualizar as telas de pagamento em local/dev/hml sem depender da API
 * ou do Pagar.me. Ativado via featureFlags.mockCheckoutResponse.
 */
export function mockCheckoutResponse(formaPagamento: "pix" | "boleto" | "cartao") {
  const checkoutId = "mock-checkout-id";
  const status = "PENDING";
  const orders: unknown[] = [];

  if (formaPagamento === "pix") {
    return {
      checkoutId,
      status,
      orders,
      paymentDetails: {
        type: "pix",
        qrCode:
          "00020126580014BR.GOV.BCB.PIX0136mock-pix-000000000000000000005204000053039865802BR5913Loja Mock6009SAO PAULO62070503***6304MOCK",
        qrCodeUrl: "https://via.placeholder.com/240x240.png?text=QR+Code+PIX",
      },
    };
  }

  if (formaPagamento === "boleto") {
    return {
      checkoutId,
      status,
      orders,
      paymentDetails: {
        type: "boleto",
        barcode: "23793.38128 60007.827136 66000.063305 1 96790000015000",
        url: "https://example.com/mock-boleto.html",
        pdf: "https://example.com/mock-boleto.pdf",
      },
    };
  }

  return { checkoutId, status, orders };
}
